import type { InvitePreview } from "../model/Invitation";
import type { InvitationService } from "../port/InvitationService";

export class PreviewInvitation {
  constructor(
    private readonly service: InvitationService,
  ) {}

  execute(token: string, signal?: AbortSignal): Promise<InvitePreview> {
    return this.service.previewInvitation(token, signal);
  }
}
